import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[cellPhoneMask]',
    standalone: false
})
export class CellPhoneMaskDirective {

  constructor(private el: ElementRef) { }

  
  @HostListener('input', ['$event'])
  onInput(event: any): void {
    const value = this.el.nativeElement.value.replace(/\D/g, '');
    let formattedValue = '';
    if (value.length > 0) {
      formattedValue += value.substring(0, 2);
    }
    if (value.length > 2) {
      formattedValue += ' ' + value.substring(2, 6);
    }
    if (value.length > 6) {
      formattedValue += ' ' + value.substring(6, 10);
    }
    this.el.nativeElement.value = formattedValue;
  }
}
